import { call, put, takeLatest } from 'redux-saga/effects';
import {
    loadedPatients,
    updatedPatient,
    REQUEST_PATIENTS,
    SEARCH_REQUEST_PATIENTS,
    REQUEST_PROFIL_PATIENT,
    REQUEST_CONSULTATIONS_PATIENT,
    UPDATE_PATIENT
} from '../actions/patients.action';
import {Patients, Practitioners} from '../api/index';
import {loadedConsultations} from "../actions/consultations.action";
import {toast} from "react-toastify";

export function* requestListPatients() {
    try {
        let patients = yield call(() => Patients.all());
        yield put(loadedPatients(patients.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* searchPatients(payload) {
    try {
        let patients = null;
        if (payload.data.search.length > 0) {
            patients = yield call(() => Patients.search(payload.data.search));
        } else {
            patients = yield call(() => Patients.all());
        }
        yield put(loadedPatients(patients.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* requestProfilPatient({payload}) {
    try {
        let patient = yield call(() => Patients.profil(payload));
        yield put(loadedPatients(patient.data));
    } catch  (err){
        toast.error(err.response.data.message);
    }
}

export function* requestConsultationsPatient({payload}) {
    try {
        let patient = yield call(() => Patients.getConsultations(payload));
        yield put(loadedConsultations(patient.data));
    } catch  (err){
        toast.error(err.response.data.message);
    }
}

export function* updatePatient(payload) {
    try {
        yield call(() => Patients.update(payload));
        yield put(updatedPatient());
        let patient = yield call(() => Patients.profil(payload.id));
        yield put(loadedPatients(patient.data));
        toast.success('Profil mis à jour')
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* watchRequestListPatients(){
    yield takeLatest(REQUEST_PATIENTS, requestListPatients);
}

export function* watchSearchRequestPatients(){
    yield takeLatest(SEARCH_REQUEST_PATIENTS, searchPatients)
}

export function* watchRequestProfilPatient(){
    yield takeLatest(REQUEST_PROFIL_PATIENT, requestProfilPatient)
}

export function* watchRequestConsultationsPatient(){
    yield takeLatest(REQUEST_CONSULTATIONS_PATIENT, requestConsultationsPatient)
}

export function* watchUpdatePatient(){
    yield takeLatest(UPDATE_PATIENT, updatePatient)
}


// WEBPACK FOOTER //
// ./src/sagas/patients.saga.js